module.exports = __webpack_public_path__ + "static/media/regal_mit_flashe_markiert.4e87b807.jpg";